import { isMobile } from '@resources/js/helpers/media'
import Modal from '@resources/js/ui/Modal'
import CookiePolicy from '@resources/js/components/cookie-policy/CookiePolicy'
import '@resources/js/components/cookie-policy/initHotjarIfCookiesAllowed'

const initCookiePolicy = () => {
	if (CookiePolicy.hasInteracted()) return

	const cookiePolicyElement = document.querySelector('.js-cookie-policy')

	const cookiePolicyModal = new Modal(cookiePolicyElement, {
		toggleClass: 'show',
		hideOnBackdrop: false,
		lockScroll: false,
	})

	cookiePolicyModal.show()

	if (!CookiePolicy.hasAllowedOptional()) {
		const cookiePolicyAcceptButton =
			cookiePolicyElement.querySelector('.js-cookie-accept')

		cookiePolicyAcceptButton.addEventListener('click', () =>
			CookiePolicy.setOptional()
		)
	}

	cookiePolicyModal.on('hide', () => CookiePolicy.setInteracted())

	if (isMobile()) {
		document.addEventListener('click', e => {
			if (!cookiePolicyElement.contains(e.target)) cookiePolicyModal.hide()
		})
	}
}

initCookiePolicy()
